import token from 'styled-token';

/** @mixin fontWeightMixin */
/**
 * Get the font weight for the given font type.
 *
 * @example
 * import { fontWeightMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     font-weight: ${fontWeightMixin('h1')};
 * `;
 *
 * <Component>h1 font weight</Component>
 *
 * @method
 * @param {string} fontType - The `fontType` key for the `fontWeights` object.
 * @param {function} [callback] - An optional callback that will be called with an object with the
 *     font weight value and suffix properties. The value returned from the function will be
 *     inserted.
 * @return {Interpolation}
 */
export var fontWeightMixin = function fontWeightMixin(fontType, callback) {
  return token('fontWeights', function (fontWeights) {
    var value = fontWeights && fontWeights[fontType];
    if (typeof callback === 'function') {
      return callback({
        value: value
      });
    }
    return value;
  });
};